/**
 * Resolves the ApexCharts theme mode ('light' | 'dark') from an Ant Design
 * colorBgBase token value.
 *
 * Ant Design may return shortened hex (#fff) or full hex (#ffffff).
 * Parsing the red-channel luminance is more reliable than strict equality.
 */
export const apexThemeMode = (colorBgBase: string): 'light' | 'dark' => {
  const hex = colorBgBase.replace('#', '');
  // Expand shorthand (#abc → aabbcc)
  const full =
    hex.length === 3
      ? hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
      : hex.padEnd(6, '0');
  const red = parseInt(full.slice(0, 2), 16);
  const grn = parseInt(full.slice(2, 4), 16);
  const blu = parseInt(full.slice(4, 6), 16);
  const luminance = (red * 299 + grn * 587 + blu * 114) / 1000;
  return luminance > 127 ? 'light' : 'dark';
};
